document.addEventListener('DOMContentLoaded', async () => {
  const container = document.getElementById('bandsintown-container');
  
  if (!container) return;

  const artist = container.dataset.artist;
  const appId = 'c528575fac385811d4d17a4b8f51513d'; // Replace with your actual App ID
  const url = `https://rest.bandsintown.com/artists/${artist}/events?app_id=${appId}&date=upcoming`;

  try {
    const response = await fetch(url);
    const events = await response.json();

    if (!Array.isArray(events) || events.length === 0) {
      container.innerHTML = '<p style="text-align:center;">No upcoming shows at the moment. Check back soon!</p>';
      return;
    }

    let html = '<div class="tour-dates-list">';

    events.forEach(event => {
      const dateObj = new Date(event.datetime);
      
      const month = dateObj.toLocaleString('default', { month: 'short' }).toUpperCase();
      const day = String(dateObj.getDate()).padStart(2, '0');
      
      // Extract and format the time (e.g., "8:00 PM")
      const timeString = dateObj.toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: '2-digit' 
      });

      let btnText = 'Tickets';
      let eventUrl = event.url;

      if (!event.offers || event.offers.length === 0) {
        btnText = 'Notify Me';
        eventUrl += (eventUrl.includes('?') ? '&' : '?') + 'trigger=notify_me';
      }

      html += `
        <div class="tour-date-row">
          
          <div class="tour-date-wrapper">
            <div class="tour-date-time">
              <span class="tour-month">${month}</span>
              <span class="tour-day">${day}</span>
            </div>
            <div class="tour-time">${timeString}</div>
          </div>

          <div class="tour-date-info">
            <span class="tour-venue truncate-text">${event.venue.name}</span>
            <span class="tour-location truncate-text">${event.venue.city}, ${event.venue.region || event.venue.country}</span>
          </div>
          
          <div class="tour-date-action">
            <a href="${eventUrl}" target="_blank" rel="noopener noreferrer" class="tour-ticket-btn">${btnText}</a>
          </div>
        </div>
      `;
    });

    html += '</div>';
    container.innerHTML = html;

  } catch (error) {
    console.error('Error fetching tour dates:', error);
    container.innerHTML = '<p style="text-align:center;">Unable to load tour dates right now. Please try again later.</p>';
  }
});